module.exports = __webpack_public_path__ + "static/media/curated-hp-2.fa7b4ba7.jpg";